// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"style_tooltip__1eKwQ"};